import _ from 'lodash';
import { SEGMENT_CONFIG } from 'v2/common/constants/index';
import { schemaShouldShowConfigTypes, schemaTypes } from '../outputSchema/config';
import { pipeInputSchemaTypes } from './config';

const isPrivilegedUser = _.get(window, 'isPrivilegedUser', false);

const configuration = {
  type: 'bollingerBand',
  defaults: {
    chartConfig: {
      type: 'candle',
      boxUnitSize: 0,
      boxPercentage: 0,
      volumeInterval: '3 minutes',
    },
    type: 'bollingerBand',
    name: 'BB',
    config: {
      noOfCandles: 20,
      multiplier: 2,
      candleInterval: '5 minutes',
      valuePaths: [
        'item0.equity'
      ]
    }
  },
  searchTerms: [
    'Bollinger Band'
  ],
  inputSchema: [
    {
      name: 'noOfCandles',
      type: pipeInputSchemaTypes.number,
      label: 'Period',
    }
  ],
  configFormOptions: {
    valuePathEditable: true,
    configFieldOptions: {},
    valuePathSupportedSegments: [SEGMENT_CONFIG.equity, SEGMENT_CONFIG.future],
    isDayCandleEnabled: isPrivilegedUser
  },
  buildOutputSchema: (pipe) => {
    const { name, type } = pipe;
    const properties = [
      'upperBollingerBand',
      'middleBollingerBand',
      'lowerBollingerBand'
    ];

    return _.map(properties, (property) => {
      return {
        name: `${name}.${property}`,
        type: schemaTypes.number,
        indicatorType: type,
        category: 'indicator',
        label: name === property ? name : `${name} ${property}`,
        shouldShowConfigs: [
          schemaShouldShowConfigTypes.adjustmentLeftOperand,
          schemaShouldShowConfigTypes.adjustmentRightOperand,
          schemaShouldShowConfigTypes.entryLeftOperand,
          schemaShouldShowConfigTypes.entryRightOperand,
          schemaShouldShowConfigTypes.exitLeftOperand,
          schemaShouldShowConfigTypes.exitRightOperand,
          schemaShouldShowConfigTypes.intentValuePath,
        ],
        priority: 70,
        schemaName: name
      };
    });
  },
  isEnabled: true,
  priority: 6
};
export default configuration;
